import type { EmojiCategory } from "@/src/shared/emoji/types";

export const getEmojiPickerCategoryLabel = (category: EmojiCategory): string => {
  return window.I18n.designSystem.emojiPicker.categories[category];
};
